import { Component } from '@angular/core';
import { BookDemoService } from '../../../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-ts-v2-pipeline-section',
  templateUrl: './pipeline-section.component.html',
  styleUrls: ['./pipeline-section.component.scss'],
})
export class V2PipelineSectionComponent {
  constructor(private bookDemo: BookDemoService) {}

  openBookDemo(): void {
    this.bookDemo.open();
  }
}
